/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ForecastAdjustmentCalculationType = 'Add' | 'Percentage';

export const ForecastAdjustmentCalculationType = {
    Add: 'Add' as ForecastAdjustmentCalculationType,
    Percentage: 'Percentage' as ForecastAdjustmentCalculationType
};

